import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-2015">
      <About data-id="element-2016" />
    </main>;
}